import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="border-t border-gray-100 bg-white py-16">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-12 flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
          <div>
            <p className="mb-2 text-xl font-semibold text-gray-900">Greyfield Data</p>
            <p className="text-gray-500">Snowflake, Sigma, dbt, and reporting systems</p>
          </div>
          <div className="flex flex-col gap-6 md:flex-row md:flex-wrap md:gap-x-8 md:gap-y-4">
            <Link to="/services/snowflake-consulting" className="text-gray-500 transition hover:text-gray-900">Snowflake</Link>
            <Link to="/services/sigma-consulting" className="text-gray-500 transition hover:text-gray-900">Sigma</Link>
            <Link to="/resources" className="text-gray-500 transition hover:text-gray-900">Resources</Link>
            <a href="mailto:linus@greyfielddata.com" className="text-gray-500 transition hover:text-gray-900">linus@greyfielddata.com</a>
            <a href="https://www.linkedin.com/company/greyfield-data" target="_blank" rel="noopener noreferrer" className="text-gray-500 transition hover:text-gray-900">LinkedIn</a>
            <Link to="/privacy" className="text-gray-500 transition hover:text-gray-900">Privacy</Link>
          </div>
        </div>
        <div className="border-t border-gray-100 pt-8 text-center">
          <p className="text-sm text-gray-400">&copy; {new Date().getFullYear()} Greyfield Data. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
